<template>
  <div class="home" v-loading="loading" ref="home">
    <el-header style="border-bottom: 1px solid rgb(221, 221, 221);padding:0px">
      <div class="logo" style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;width: 60%;">
        <img src="@/assets/img/cszq_logo.png" alt style="width: 160px;height: 40px;"/>
      </div>
      <div class="right-icon">
        <el-dropdown trigger="click" @command="handleSelect">
            <span class="el-dropdown-link">
                <i style="font-size: 30px;" class="el-icon-s-operation"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, index) in navList" :key="index" :command="item.path">
                    {{ item.name }}
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <swiper class="carousel" :options="swiperOption" ref="swiper">
        <swiper-slide class="carousel-item">
            <div class="home-header">
                <div class="home-header-content">
                    <p style="color: #ff821f;">长胜证券</p>
                    <p style="color: #ff821f;">欢迎来到长胜证券</p>
                    <p style="font-size: 12px;">香港长胜证券有限公司（注册号：3186606）是全球领先的互联网券商。在新的时代，科技创新使投资者能随时随地参与港股、沪深股、环球期货及杠杆式投资等交易市场。长胜证券致力于创造更简易的交易软件、安全的投资平台，让投资变得更轻松、简单、智能。</p>
                    <div class="into-web" @click="toPartner('https://pc.csgg002.vip:5335/#/home')">进入官网</div>
                </div>
            </div>
        </swiper-slide>
        <swiper-slide class="carousel-item" v-for="(item, index) in carousel" :key="index">
            <img :src="require('@/assets/img/' + item.img)"  />
        </swiper-slide>

        <!-- 分页点 -->
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div ref="ourserve" class="our-values">
      <div class="our-values-title">
        我们的服务
        <div class="title-bottom" style="font-size: 13px;">
          <div class="title-label">OUR SERVICE</div>
          <div class="title-icon"></div>
        </div>
      </div>
      <div class="our-tabs">
        <div class="our-tabs-item"
         :class="ourServeTabsActive === index ? 'active' : ''"
         v-for="(tab,index) in ourServeTabs"
        :key="index"
        @click="ourServeTabsActive = index">
          {{ tab.text }}
        </div>
      </div>
      <div class="our-cases-content">
        <div class="video-info">
          <h3 style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
            {{ourServeTabs[ourServeTabsActive].text}}
          </h3>
          <p
            v-for="(detail, detailIndex) in ourServeTabs[ourServeTabsActive].details"
            :key="detailIndex"
              v-html="formatDetail(detail)">
          </p>
        </div>
      </div>
    </div>
    <div class="our-values" ref="companyculture">
      <div class="our-values-title">
        企业文化
        <div class="title-bottom" style="font-size: 13px;">
          <div class="title-label">COMPANY CULTURE</div>
          <div class="title-icon"></div>
        </div>
      </div>
      <div class="our-cases-content" style="padding-top: 20px;">
        服务定位：长胜证券将秉承“体验至上、用户第一”的理念，不断推动产品叠代升级，推出更多普惠投资者、企业和行业的产品及服务，成为有显著影响力的全球金融服务平台。
      </div>
      <div class="our-cases-content">
        企业使命：成为具有显著影响力的全球金融服务平台！让投资更简单安全！
      </div>
      <div class="our-cases-content">
        正直诚信：以身作则、刚正不阿、公正处事<br/>
        高效可靠：工作高效、为人靠谱、产品好用<br/>
        卓越服务：满足需求、预判需求、创造惊喜<br/>
        追求极致：雕琢细节、积极行动、牢记使命
      </div>
    </div>
    <div class="our-values" ref="aboutus">
      <div class="our-values-title">
        关于我们
        <div class="title-bottom" style="font-size: 13px;">
          <div class="title-label">ABOUT US</div>
          <div class="title-icon"></div>
        </div>
      </div>
      <div class="title-content">长胜证券有限公司</div>
      <div class="about-us" style="padding-top: 10px;">
        <div class="us-left">
          <h3>关于我们</h3>
          <p>长胜证券有限公司</p>
          <!-- <div class="us-content">
            香港长胜证券有限公司（注册号：3186606）是全球领先的互联网券商。在新的时代，科技创新使投资者能随时随地参与港股、沪深股、环球期货及杠杆式投资等交易市场。长胜证券致力于创造更简易的交易软件、安全的投资平台，让投资变得更轻松、简单、智能。
          </div> -->
          <div class="us-content">
            作为第三代券商，领先的技术和研发能力是长胜的优势。我们的团队不仅有热爱交易，也是一群追求极致体验的精英。在长胜证券，近一半的员工为研发人员，主要来自于证券、银行、IT等行业，具备丰富的证券、金融及私募领域从业经验。我们通过金融科技创新从底层重构交易系统，具有很高的可访问性、可靠性、高安全性、高扩展性、低延迟性。全自研的技术架构使我们能不断推出更加创新、安全、可靠的产品功能和绝佳的用户体验。
          </div>
          <div class="us-content">
            作为先锋互联网券商，长胜证券扎根香港，放眼全球，以高效、专注、可靠、创新、灵活为经营理念，比传统券商更善于利用科技来提高运营效率和客户体验。自主研发的交易平台，让开户更便捷、费率更低、使用体验更好、更加本地化，为全球华人投资者提供一站式全方位的投资服务平台。
          </div>
        </div>
      </div>
    </div>
    <div class="content-partner" ref="partner">
      <div class="top">
        <h3>合作伙伴</h3>
        <p>RARTNERS</p>
        <ul class="partner-img">
          <li v-for="(partner,i) in partnerImg" :key="i" @click="toPartner(partner.Url)">
            <img v-lazy="require('@/assets/img/' + partner.Img)" alt />
          </li>
        </ul>
      </div>
    </div>
    <!-- 侧边栏 -->
    <div v-if="visible" class="sidebar-mask" @click="closeSidebar"></div>
    <div
      class="sidebar"
      :class="{ 'sidebar-show': visible }"
    >
      <!-- <div class="sidebar-header">
        <span>菜单</span>
        <span class="close" @click="closeSidebar">×</span>
      </div> -->
      <div class="sidebar-content">
        <div class="sidebar-menu">
            <div class="menu-item" v-for="(item, index) in navList" :key="index" @click="handleSelect(item.path)">
                {{item.name}}
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import data from "../../assets/data.json";
export default {
  name: "HelloWorld",
  data() {
    return {
      router: true,
      visible: false,
      defaultActive: "home",
      loading: false,
      ourValues: [],
      ourCase: [],
      teamItem: [],
      partnerImg: [],
      timer: null,
      hovering: false,
      scrollY: 0,
      lastScrollY: 0,
      scrollDirection: 'down',
      hasEntered: false,
      scrollProgress: 0,
      scrollCaseProgress: 0,
      caseAnimation: false,
      selected: 0,
      ourServeTabsActive: 0,
      swiperOption: {
        loop: true,
        autoplay:{ delay: 3500, disableOnInteraction: false },
        pagination: false
      },
      carousel: [
        {
          img: 'cszq_banner_1_mobile.png',
        },
        {
          img: 'cszq_banner_2_mobile.png',
        },
        {
          img: 'cszq_banner_3_mobile.png',
        }
      ],
      navList:[
         {
           id:0,
           name:'长胜证券',
           path:'home'
         },
         {
           id:1,
           name:'我们的服务',
           path:'ourserve'
         },
         {
           id:2,
           name:'企业文化',
           path:'companyculture'
         },
         {
           id:3,
           name:'关于我们',
           path:'aboutus'
         },
         {
           id:4,
           name:'合作伙伴 ',
           path:'partner'
         },
      ],
      ourServeTabs: [
        {
          text: "新手指引",
          details:[
            {
              key:"第一步",
              value:`点击“用户中心”。`
            },
            {
              key:"第二步",
              value:`点击 "在线注册"分别填写 "手机号"-"验证码"-"手机验证码"-"密码"-"推荐人推广码"(可填可不填)。`
            },
            {
              key:"第三步",
              value:`点击 "用户登录"   分别输入 "手机号"-"密码"-"验证码"—点击进入。`
            },
            {
              key:"第四步",
              value:`点击 "用户中心"-选择 "充值"，"充值金额"，填写 "相关信息"-点击 "我已成功付款"提交。`
            },
            {
              key:"第五步",
              value:`选择您的配资玩法-直接点击 "按天配资" "按月配资" "按周配资" "免息配资"。`
            },
            {
              key:"第六步",
              value:`提交申请之后,我们可以点击 "配置交易"-点击 "交易" -选择 "配资账户"-进行 "实盘交易"。`
            },
            {
              key:"第七步",
              value:`点击实盘交易后进入实盘操作-输入 股票代码-选择 购买信息-点击 买入。`
            },
            {
              key:"第八步",
              value:`实盘交易 "确认"后,可以到 交易页面-"委托"里面进行查询。`
            },
            {
              key:"第九步",
              value:`完成后到 "配资账户"-"申请结算"进行，可以直接提现或者是继续其他配资。`
            },
            {
              key:"第十步",
              value:`提现：提现前您需要先到 "用户中心"-"实名认证"-认证完即可提现。`
            }
          ]
        },
        {
          text: "配资指南",
          details:[
            {
              key:"如何注册会员?",
              value:`
              第一步：点击官网，点击立即注册。
              第二步：按照提示填入手机号码，登录密码，图形验证码，短信验证码，推荐码（选填），勾选《网站的服务协议》 。
              第三步：点击完成注册。`,
            },
            {
              key:"如何进行充值?",
              value:`
              第一步：登录-实名认证。
              第二步：点充值，输入金额和选择充值方式，转账后点确认。
              第三步：等待网站确认，一般2-10分钟，充值到账，账户余额可查看。`,
            },
            {
              key:"如何申请配资开户?",
              value:`
              第一步：登录到会员中心。
              第二步：选择配资，并选择配资方案，保证金，杠杆配资，余额充足的情况下，开户立即成功。`
            },
            {
              key:"如何股票交易？",
              value:`
              第一步：登录-申请配资开户。
              第二部：成功后，方法1-在用户中心选择配资账户，然后到指定的子账户点实盘交易，方可进入交易界面交易。方法2-在用户中心选择实盘交易，进入交易界面后可选择子账户进行交易。`
            }
          ]
        },
        // {
        //   text: "交易规则",
        //   details:[
        //             {
        //         key: '1、配资管理费：是指用于支付配资的利息。分别为',
        //         value: `
        //     \r\n1.1、按日配资，日利率0.06%
        //     \r\n1.2、按周配资，周利率0.3%
        //     \r\n1.3、按月配资，月利率1%
        //     \r\n1.4、免息配资，免收管理费（盈利时平台收取12%盈利分成，亏损自负）
        //     \r\n首期管理费从代金券和总账户余额中依次扣取，新建配资子账号时收取
        //     \r\n续期管理费从代金券和子账户余额中依次扣取
        //     \r\n当前总资产(股票市值+冻结金额+子账户余额)大于平仓线的情况下，子账户余额可为负数
        //     `
        //       },

        //       {
        //         key: '2、交易费用：是指股票交易中的费用，包含',
        //         value: `
        //     \r\n2.1、印花税：与券商同步，卖的时候才收取，此为国家税收，全国统一
        //     \r\n2.2、过户费：与券商同步
        //     \r\n2.3、交易佣金：与券商同步
        //     \r\n以上费用从子账户中扣取
        //     `
        //       },

        //       {
        //         key: '3、配资总操作资金',
        //         value: `
        //     \r\n即为配资后的总操作资金 = 保证金 + 配资资金
        //     \r\n包含所有首期续期的配资保证金、非配资保证金和配资资金
        //     `
        //       },

        //       {
        //         key: '4、配资资金使用期限',
        //         value: `
        //     \r\n按天：2个交易日起
        //     \r\n按周：7天含周六周日
        //     \r\n按月：30天含周六周日
        //     \r\n以上合约默认自动延期
        //     \r\n免息配资：30天含周六周日，不可续期
        //     \r\n如遇法定节假日不开市，将自动延长对应天数
        //     `
        //       },

        //       {
        //         key: '5、风险保证金',
        //         value: `
        //     \r\n是指按照一定比率交纳资金作为履行合约的财力担保
        //     \r\n用于支付结算时的亏损金额，如无亏损全额退还
        //     \r\n1-参与配资的保证金：可改变总资产、警戒线、平仓线
        //     \r\n2-不参与配资的保证金：不改变警戒线和平仓线，仅改变总资产
        //     \r\n两种保证金均计入子账户余额
        //     `
        //       },

        //       {
        //         key: '6、当前总资产',
        //         value: `
        //     \r\n当前总资产 = 股票市值 + 冻结金额 + 子账户余额
        //     \r\n是警戒线和平仓线的唯一风险控制参照指标
        //     \r\n当前总资产 ≤ 警戒线：限制买入
        //     \r\n当前总资产 ≤ 平仓线：强制平仓并结算
        //     `
        //       },

        //       {
        //         key: '7、亏损警戒线',
        //         value: `
        //     \r\n亏损警戒线 = 配资资金 + 配资保证金 × 0.5
        //     \r\n低于警戒线将限制买入新的股票
        //     \r\n可通过追加保证金解除限制
        //     \r\n不改变警戒线：追加保证金 > (警戒线 - 当前总资产)
        //     \r\n改变警戒线：追加保证金 > (警戒线 - 当前总资产) / 0.5
        //     `
        //       },

        //       {
        //         key: '8、亏损平仓线',
        //         value: `
        //     \r\n亏损平仓线 = 配资资金 + 配资保证金 × 0.2
        //     \r\n低于平仓线将按市价强制平仓
        //     \r\n存在时间差，亏损比例可能浮动
        //     \r\n最大亏损按100%计算（穿仓免责）
        //     \r\n追加保证金可避免被平仓
        //     \r\n强制平仓后子账号将自动结算
        //     `
        //       },

        //       {
        //         key: '9、除权除息',
        //         value: `
        //     \r\n送股、派息、配股将在除权除息日派送
        //     \r\n增加的股票数量当日可卖
        //     \r\n最后一次卖出数量必须大于赠送数量
        //     \r\n派息可在子账户资金记录中查看
        //     `
        //       },

        //       {
        //         key: '10、停牌股票处理',
        //         value: `
        //     \r\n停牌持仓属于用户个人行为，风险自担
        //     \r\n停牌期间管理费正常计算
        //     \r\n可申请平台按停牌前收盘价收回
        //     \r\n平台有权拒绝异常高风险个股
        //     `
        //       },

        //       {
        //         key: '11、提现规则',
        //         value: `
        //     \r\n为防止洗钱及套利行为
        //     \r\n充值后须至少配资买入一次方可提现
        //     `
        //       },

        //       {
        //         key: '12、交易限制',
        //         value: `
        //     \r\n12.1、不得购买权证类T+0股票
        //     \r\n12.2、不得购买*ST股票
        //     \r\n12.3、不得购买无涨跌停限制股票
        //     \r\n12.4、不得购买价格低于2元的股票
        //     \r\n12.5、不得进行违法违规交易行为
        //     `
        //       },

        //       {
        //         key: '13、交易时间',
        //         value: `
        //     \r\n交易日 9:30-11:30
        //     \r\n13:00-14:55
        //     \r\n股市有风险，投资需谨慎
        //     `
        //   }
        //   ]
        // },
        {
          text: "帮助中心",
          details: [
            {
              key: '什么是金融杠杆原理?',
              value: '\r\n答：在金融衍生品中，资金杠杆原理与这个规则本质上类似，都是以一定比率的保证金撬动大资金，是金融业中最常见的投资手段，例如股票配资、外汇、期货交易、黄金等贵金属交易。比如，常见的股票配资的杠杆比例为1:10，相当于10万的股票，你只用给1万就可以交易，假设股票上涨10%，也就是10万的10%即上涨到101万，你就赚了1万 ，相当于本金上涨了100%。'
            },
            {
              key: '为什么杠杆原理的投资要注意止损？',
              value: '\r\n答：杠杆原理既然能放大收益，也能放大亏损，风险与收益总是相对的，没有投资是没有风险的？关键就在于你是否懂得控制。'
            },
            {
              key: '股票配资发生纠纷如何处理？',
              value: '\r\n答：配资业务实质上属于借贷关系，配资者和配资公司必须共同遵守合同，有纠纷必须以合同为准，协商处理，若协商不了，双方可以选择起诉。配资者在配资前一定要把合同全部了解清楚，签署的文件资料需要全部做保留。共同遵守合同条款，比如平仓行为，配资公司设置平仓线主要是为了防范风险，万一配资者的账户到了平仓线，配资系统是有权将账户进行股票平仓的，最后账户盈亏由配资者自负。 如果投资者个人在平仓行为发生后认为不合理，这个就需要配资双方协商；如果是配资公司违约，投资者在协商不行的情况下可以选择起诉。'
            }
          ]
        },
        {
          text: "联系我们",
          details: [
            {
              key: '',
              value: '香港长胜证券有限公司'
            },
            {
              key: '',
              value: '香港九龙观塘路398号'
            },
            {
              key: '客服热线',
              value: '+852-67649713（香港直线 ）'
            },
            {
              key: '客服邮箱',
              value: 'cszq397@gmail.com'
            }
          ]
        },
      ],
      caseGem: [
        {
          title: "GLAWODE",
          id: 0,
          video: "",
          img: "GLAWODE_10.jpg",
          icon: "GLAWODE.png",
          details: [
            {
              key: "主旨",
              value: "增强妇女权能作为可持续发展基石的愿景已成为全球讨论的焦点，最近的一些高调活动强调了通过中国、斯里兰卡以及国际利益相关方之间的合作与创新促进性别平等的重要性。"
            },
            {
              key: '代表女性',
              value: 'GLAWODE项目的主要发力国际女性：\r\n<a href="https://en.wikipedia.org/wiki/Moza_bint_Nasser">1. 卡塔尔皇太后Moza</a>\r\n<a href="https://en.wikipedia.org/wiki/Mariam_Almheiri">2. 阿联酋总统办公室国际关系主任Mariam</a>\r\n<a href="https://en.wikipedia.org/wiki/Chea_Serey">3. 柬埔寨央行行长谢丝蕾 她是柬埔寨数字支付和数字经济全面改革的主要推手，在国际上享有很高的声誉</a>'
            }
          ]
        },
        {
          title: "CHINUSA",
          id: 1,
          video: "video/GLAWODE.mp4",
          icon: "CHINUSA.png",
          details: [
            {
              key: ' 主旨',
              value: 'CHINUSA是中国-阿联酋-美国未来伙伴机制，是为了实现HACOLAB三大使命的根本机制。'
            },
            {
              key: '代表课题',
              value: '\r\n1.经济发展与财富增长。\r\n2.生命科学与健康关怀。\r\n3.可持续地球与星际未来。'
            },
          ]
        }
      ]
    };
  },

  created() {},
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.ourValues = data.ourValues;
    this.ourCase = data.ourCase;
    this.teamItem = data.goin.team;
    this.partnerImg = data.goin.partners;
     window.addEventListener('scroll', this.handleScroll, { passive: true })
    // window.addEventListener("scroll", this.handleScroll);
    // this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    playVideo(number) {
      let refName = "video" + number
      this.timer = setTimeout(() => this.$refs[refName][0].play(), 600);
      this.hovering = true
    },
    pauseVideo(number) {
      let refName = "video" + number
      clearTimeout(this.timer);
      this.$refs[refName][0].pause();
      this.$refs[refName][0].currentTime = 0;
      this.hovering = false
    },
    getStyle(index) {
      const containerPadding = 80;
      const screenWidth = window.innerWidth * 0.8;
      const itemPerRow = 9;

      const itemWidth = (screenWidth - containerPadding) / itemPerRow;
      const itemHeight = itemWidth; // 正方形卡片

      const col = index % itemPerRow;
      const row = Math.floor(index / itemPerRow);

      const maxX = col * itemWidth;
      const maxY = row * itemHeight;

      const centerX = (screenWidth - itemWidth) / 2;
      const centerY = 0;

      let x, y;

      // 进度小于 1 时，逐步偏移；等于 1 时就定格在最大位置
      if (this.scrollProgress < 1) {
        x = centerX + (maxX - centerX) * this.scrollProgress;
        y = centerY + (maxY - centerY) * this.scrollProgress;
      }
      else {
        x = maxX;
        y = maxY;
      }

      return {
        position: 'absolute',
        width: `${itemWidth}px`,
        height: `${itemHeight}px`,
        transform: `translate(${x + 20}px, ${y}px) scale(${0.5 + 0.5 * this.scrollProgress})`,
        opacity: 1,
        transition: 'transform 0.5s ease, opacity 0.5s ease',
        zIndex: 100 - index,
      };
    },
    getCaseClass(index) {
      let className = ''
      if(this.scrollCaseProgress < 0.1){
        if (this.scrollDirection === 'down') {
          className = 'case-hidden'
        }
        else {
          className = 'fade-out ' + (index % 2 === 0 ? 'to-left' : 'to-right');
        }
      } else if (this.scrollCaseProgress < 2.5) {
        // 初始聚拢动画
        className = 'fade-in ' + (index % 2 === 0 ? 'from-left' : 'from-right');
        // 播放视频
        this.caseGem.forEach((item, index) => {
          this.playVideo(index)
        })
      } else if (this.scrollCaseProgress > 2.5) {
        // 滚动超过后开始向两边散开
        className = 'fade-out ' + (index % 2 === 0 ? 'to-left' : 'to-right');
      } else{
        // 中间状态保持不动
        className = '';
      }
      return className
    },
    handleScroll() {
      // 以「页面中线」作为判断基准
      const scrollMiddle = window.innerHeight / 2

      for (let i = 0; i < this.navList.length; i++) {
        const { path, key } = this.navList[i]
        const el = this.$refs[path]
        if (!el) continue

        const rect = el.getBoundingClientRect()

        // 如果页面中线落在当前盒子范围内
        if (rect.top <= scrollMiddle && rect.bottom >= scrollMiddle) {
          if (this.active !== key) {
            this.active = key
          }
          break
        }
      }
    },
    // handleScroll() {
    //   const scrollY = window.scrollY;
    //   const containerTop = this.$refs.container.offsetTop;
    //   const caseTop = this.$refs.case.offsetTop;
    //   const maxScroll = 50; // 拉伸展开区间（px）
    //   const triggerScroll = 500;
    //   const relativeScroll = scrollY - containerTop + 600; // 微调触发区域
    //   const relativeCaseScroll = scrollY - caseTop + 800;
    //   this.scrollProgress = Math.min(Math.max(relativeScroll / maxScroll, 0), 1);
    //   this.scrollCaseProgress = Math.min(Math.max(relativeCaseScroll / triggerScroll, 0), 3);
    //   this.scrollDirection = scrollY > this.lastScrollY ? 'down' : 'up';
    //   this.lastScrollY = scrollY;
    // },
    selectOption(index) {
      this.selected = index;
      this.changeSwiper(index);
    },
    carouselChange(index) {
      this.selectOption(index);
    },
    // 切换幻灯片
    changeSwiper(index) {
      this.$refs['carousel'].setActiveItem(index)
    },
    formatDetail(detail) {
      const text =( detail.key ? detail.key + ' ' : '') + detail.value;
      const withLineBreaks = text.replace(/\r?\n/g, '<br/>');
      return withLineBreaks.replace(
        /<a /g,
        '<a style="text-decoration: none; color: #409eff" target="_blank" '
      );
    },
    goToCaseDetails(id) {
      this.$router.push({
        name: 'casedetails',
        params: {
          id: id,
        },
      });
    },
    goTo(routerName) {
      // 如果routerName为空，提示暂不开放
      if (!routerName) {
        this.$message({
          message: '暂不开放',
          type: 'warning',
        });
        return
      } else {
        // 路由跳转
        this.$router.push({
          name: routerName,
        });
      }
    },
    toPartner(url) {
      window.open(url)
    },
    handleSelect(key) {
      this.scrollToBox(key)
    },
    scrollToBox(refName, key) {
      const el = this.$refs[refName]
      if (!el) return

      const rect = el.getBoundingClientRect()
      const scrollTop = window.pageYOffset
      const target = rect.top + scrollTop - window.innerHeight / 2

      this.closeSidebar()
      // this.defaultActive = key
    //   this.defaultActive = ''


      window.scrollTo({
        top: target,
        behavior: 'smooth'
      })
    },
    openSidebar() {
        this.visible = true
        document.body.style.overflow = 'hidden'
    },
    closeSidebar() {
        this.visible = false
        document.body.style.overflow = 'auto'
    },
  },
};
</script>
<style lang="scss" scoped>
.home{
  // width: 100%;
  min-height: calc(100vh - 100px);
  overflow: hidden;
  padding: 0px 0px 0px 0px;
  font-family: 'Poppins', 'Helvetica Neue', 'Segoe UI', 'Arial', sans-serif;
  color: #333;
  line-height: 1.6;
  letter-spacing: 0.5px;
  font-weight: 400;
  font-size: 12px;
  .right-icon{
    font-size: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
  }
  .right-icon:active{
    // 放大 0.3秒后复原
    transform: scale(1.1);
    transition: transform 0.3s ease;
  }
}
.home-header{
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 20px 15px 10px 15px;
  .home-header-content {
    p {
      // text-align: center;
      font-size: 15px;
      font-weight: bold;
    }
    .header-title{
      padding: 5px;
    }
    .header-content{
      // 首行缩进
      padding: 10px 0px;

    }
    .into-web{
      width: 60px;
      padding: 5px;
      background: #ff821f;
      border-radius: 5px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      cursor: pointer;
      font-size: 12px;
      margin: 20px auto 0px auto;
    }
    .into-web:active{
      // 放大 0.3秒后复原
      transform: scale(1.1);
      transition: transform 0.3s ease;
    }
  }
  .image-view{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
.our-values{
  // background: rgb(248,249,250);
  padding: 5px 0px;
  border-radius: 10px;
  margin: 0px 0px;
  .our-values-title{
    padding: 5px 5px 0px 5px;
    // margin-left: 10px;
    // font-weight: bold;
    font-size: 15px;
    width: 100%;
    color: #000;
    text-align: center;
    border-bottom: solid 1px rgb(221, 221, 221);
    .title-bottom{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      .title-icon{
        height: 3px;
        background: #ff821f;
        width: 150px;
      }
    }
  }
  .title-content{
    padding-top: 5px;
    color: #999;
    font-size: 12px;
    font-weight: normal;
    text-align: center;
  }
  .our-values-content{
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    height: 200px;
    padding: 10px 20px;
    // position: relative;
    .our-values-content-item{
      width: calc(100% / 9 - 10px);
      // border-radius: 12px;
      // box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      // text-align: center;
      // font-size: 20px;
      // color: #333;
    }
    .our-values-content-item img {
      width: 100%;
      border-radius: 8px;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s;
    }
    .our-values-content-item img:hover {
      transform: scale(1.1);
      z-index: 1000;
    }
  }
  .our-cases-content{
    padding: 0px 20px 0px 20px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    border-radius: 10px;
    .video-info{
      width: 100%;
      h3{
        font-size: 15px;
      }
    }
    .our-cases-content-item{
      width: 33%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      // padding: 5px;
    }
    .our-cases-video-item{
      width: 49%;
      background: #fff;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-content: center;
      .video-info {
        padding: 24px;
        background: #ffffff;
        // border-radius: 0px 12px 12px 0px;
        // box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
        animation: fadeIn 0.3s ease forwards;
        opacity: 0;
        font-family: 'Georgia', 'Times New Roman', serif;
        color: #333;
        // border: 1px solid #e6e6e6;
        transition: all 0.3s ease;
      }
    }
  }
  .about-us{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 20px;
    .us-left{
      flex: 1;
      p{
        padding: 5px 0px;
      }
      .us-content{
        font-size: 14px;
        margin-bottom: 15px;
      }
    }
    .us-right{
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      img{
        width: 100%;
      }
    }
  }
  .our-tabs{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0px;
    .our-tabs-item{
      padding: 10px;
      margin: 0px 10px;
      cursor: pointer;
      font-size: 12px;
    }
    .our-tabs-item.active{
      background: rgb(35, 40, 59);
      color: #fff;
      border-radius: 10px;
    }
  }
}
//团队风采
.content-team {
  padding: 50px 100px;
  .swiper-img {
    height: 400px;
    background: no-repeat center;
    background-size: cover;
  }
}
//合作伙伴
.content-partner {
  padding: 10px 10px;
  .partner-img {
    width: 100vw;
    margin: 0px auto;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    li {
      width: 33vw;
    //   height: 30vw;
      list-style: none;
      margin: 10px 0px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      img {
        width: 24vw;
        height: 8vw;
        // border: 1px solid rgb(194, 218, 235);
      }
    }
  }
}
.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 18px;
    padding: 5px;
  }
  p {
    font-size: 15px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
.video-container {
  width: 320px;
  height: 180px;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.video-info-wrapper {
  display: flex;
  align-items: flex-start;
  transition: all 0.3s ease;
  width: 100%;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.video-info-wrapper video {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.video-shrink {
  max-width: 60%;
}

.video-info h3 {
  font-size: 22px;
  color: #b22222;
  margin-bottom: 16px;
  // border-bottom: 1px solid #e0e0e0;
  padding-bottom: 8px;
}

.video-info p {
  margin: 10px 0;
  font-size: 15px;
  line-height: 1.7;
  color: #555;
  position: relative;
  padding-left: 14px;
}

.video-info p::before {
  content: "◆";
  position: absolute;
  left: 0;
  color: #b22222;
  font-size: 10px;
  top: 3px;
}

.video-info h3 {
  margin: 0;
  color: #b22222;
  font-size: 20px;
  margin-bottom: 8px;
}

.video-info p {
  margin: 4px 0;
  color: #333;
  font-size: 14px;
  line-height: 1.6;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
.our-values1 {
  background: rgb(248,249,250);
  padding: 10px;
  border-radius: 10px;
  margin: 20px 0px;
}

.our-values1-title {
  // text-align: center;
  margin-bottom: 20px;
  padding: 5px;
  margin-left: 10px;
  font-weight: bold;
  font-size: 12px;
  width: 100%;
  color: #0C9EFF;
}

.our-values1-content {
  // margin-top: 500px;
  position: relative;
  height: 300px;
  width: 100%;
}

.our-values1-content-item {
  width: calc(100% / 9 - 10px);
}
.our-values1-content-item img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}
.our-values1-content-item img:hover {
  transform: scale(1.1);
  z-index: 1000;
}
.sidebar {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 10px;
}
.sidebar-option {
  // height: 150px;
  width: 50%;
  // background: #d7efe0;
  // border: 2px solid #bdd7c6;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1), inset 0 -2px 6px rgba(255, 255, 255, 0.5);
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s;
  img {
    width: 120px;
    max-height: 120px;
    // height: 28px;
    // border-radius: 50%;
    border: 1px solid #ccc;
  }

  span {
    width: 100%;
    color: #255943;
    font-weight: bold;
    text-shadow: 1px 1px #ffffff;
    text-align: center;
  }

  &:hover {
    background: #e0e0e0;
    transform: translateY(-2px);
  }

  &.active {
    background: #e0e0e0;
    border-color: #78b199;
    span {
      color: #0c3b28;
    }
  }
}
.fade-in.from-left {
  transform: translateX(-100px);
  animation: slideInLeft 0.8s forwards;
}

.fade-in.from-right {
  transform: translateX(100px);
  animation: slideInRight 0.8s forwards;
}

@keyframes slideInLeft {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
/* 👈 盒子向左滑出 */
.fade-out.to-left {
  transform: translateX(0);
  animation: slideOutLeft 0.8s forwards;
}

/* 👉 盒子向右滑出 */
.fade-out.to-right {
  transform: translateX(0);
  animation: slideOutRight 0.8s forwards;
}

@keyframes slideOutLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}

@keyframes slideOutRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
/* 初始隐藏状态 */
.case-hidden {
  opacity: 0;
  transform: translateX(150px); /* 默认从右进来，左边你可反过来写 */
  transition: none;
}

/* 从左滑入 */
.case-appear-from-left {
  animation: appearFromLeft 0.8s ease forwards;
}

/* 从右滑入 */
.case-appear-from-right {
  animation: appearFromRight 0.8s ease forwards;
}

.carousel {
  margin-top: 60px;
//   height: 400px;
  .carousel-item {
    width: 100%;
    padding-bottom: 20px;
    img{
        object-fit: cover;
        width: 100vw;
    }
  }
  .carousel-view {
  }
}

@keyframes appearFromLeft {
  0% {
    opacity: 0;
    transform: translateX(-150px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes appearFromRight {
  0% {
    opacity: 0;
    transform: translateX(150px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
/* 遮罩 */
.sidebar-mask {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 998;
}

/* 侧边栏主体 */
.sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: 60%;
  max-width: 300px;
  height: 100%;
  background: #fff;
  z-index: 999;
  transform: translateX(100%);
  transition: transform 0.3s ease;
}

/* 显示状态 */
.sidebar-show {
  transform: translateX(0);
}

/* 头部 */
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.close {
  font-size: 20px;
  cursor: pointer;
}

/* 内容 */
.sidebar-content {
  padding: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  .sidebar-menu {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .menu-item {
      width: 90%;
      margin-bottom: 10px;
      background: #ff821f;
      color: #fff;
      padding: 5px 10px;
      border-radius: 5px;
      cursor: pointer;
      text-align: center;
    }
  }
}
/* 当前激活的小圆点 */
.swiper-pagination-bullet-active {
  background: #ff821f !important;
}
</style>